import { useEffect } from 'react';

interface SEOMeta {
  title: string;
  description: string;
  keywords?: string;
  canonical?: string;
  ogType?: string;
  ogImage?: string;
  articlePublishedTime?: string;
  articleModifiedTime?: string;
}

export function useSEO(meta: SEOMeta) {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = meta.title;

    const setMetaTag = (name: string, content: string, attrName = 'name') => {
      let el = document.querySelector(`meta[${attrName}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attrName, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMetaTag('description', meta.description);
    if (meta.keywords) setMetaTag('keywords', meta.keywords);

    if (meta.canonical) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
      }
      link.setAttribute('href', meta.canonical);
    }

    setMetaTag('og:title', meta.title, 'property');
    setMetaTag('og:description', meta.description, 'property');
    setMetaTag('og:type', meta.ogType || 'website', 'property');
    if (meta.ogImage) setMetaTag('og:image', meta.ogImage, 'property');
    if (meta.canonical) setMetaTag('og:url', meta.canonical, 'property');

    setMetaTag('twitter:card', 'summary_large_image', 'name');
    setMetaTag('twitter:title', meta.title, 'name');
    setMetaTag('twitter:description', meta.description, 'name');

    if (meta.articlePublishedTime) {
      setMetaTag('article:published_time', meta.articlePublishedTime, 'property');
    }
    if (meta.articleModifiedTime) {
      setMetaTag('article:modified_time', meta.articleModifiedTime, 'property');
    }

    return () => {
      document.title = prevTitle;
    };
  }, [meta]);
}